import React from 'react'
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Filler,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip as ChartTooltip,
} from 'chart.js'
import { Bar, Line } from 'react-chartjs-2'
import moment from 'moment'
import { Box } from '@mui/material'
import TileShell from './TileShell'
import { chartBlue } from './tileColors'

ChartJS.register(BarElement, CategoryScale, LinearScale, PointElement, LineElement, Filler, ChartTooltip)

const bucketLabel = (isoDate, bucket) => {
  const date = moment(isoDate)
  if (bucket === 'month') return date.format('MMM YY')
  if (bucket === 'week') return date.format('D MMM')
  return date.format('D MMM')
}

const TrendTile = ({ kpi }) => {
  // Counts are drawn as bars: a line through sparse counts implies values
  // between the buckets that never existed.
  const isCount = kpi.unit !== 'percent' && kpi.unit !== 'minutes'
  const labels = kpi.series.map((point) => bucketLabel(point.t, kpi.bucket))
  const data = {
    labels,
    datasets: [
      {
        data: kpi.series.map((point) => point.v),
        ...(isCount
          ? { backgroundColor: chartBlue, borderRadius: 3, maxBarThickness: 18 }
          : {
              borderColor: chartBlue,
              borderWidth: 2,
              pointRadius: 0,
              pointHitRadius: 8,
              fill: true,
              backgroundColor: 'rgba(38, 142, 187, 0.08)',
            }),
      },
    ],
  }
  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context) =>
            kpi.unit === 'percent'
              ? `${context.parsed.y}%`
              : kpi.unit === 'minutes'
                ? `${context.parsed.y} min`
                : `${context.parsed.y}`,
        },
      },
    },
    scales: {
      x: { grid: { display: false }, ticks: { maxTicksLimit: 6, font: { size: 10 } } },
      y: {
        beginAtZero: true,
        ticks: { maxTicksLimit: 4, precision: isCount ? 0 : undefined, font: { size: 10 } },
        max: kpi.unit === 'percent' ? 100 : undefined,
      },
    },
  }

  return (
    <TileShell label={kpi.label} description={kpi.description} wide>
      <Box width="100%" height={120}>
        {isCount ? (
          <Bar data={data} options={options} />
        ) : (
          <Line data={data} options={options} />
        )}
      </Box>
    </TileShell>
  )
}

export default TrendTile
